import { apiRequest } from "../api/apiClient";

const ROUTE_PREFIX = "productOrder";

const orderProducts = async (
  userId: string,
  productId: string,
  cityId: string,
  city: string,
  quantity: string,
  price: string,
  addressId: string,
) => {
  const { data, error } = await apiRequest("post", `/${ROUTE_PREFIX}`, {
    userId,
    productId,
    cityId,
    city,
    quantity,
    price,
    addressId,
  });
  return { data, error };
};

const getProductOrders = async ({
  city,
  fromDate,
  toDate,
  index,
}: {
  city?: string;
  fromDate?: string;
  toDate?: string;
  index: number;
}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("index", index.toString());

  if (city && city !== "all") {
    queryParams.append("city", city);
  }

  if (fromDate && toDate) {
    queryParams.append("fromDate", fromDate);
    queryParams.append("toDate", toDate);
  }

  const { data, error } = await apiRequest(
    "get",
    `/${ROUTE_PREFIX}/admin?${queryParams.toString()}`,
  );

  return { data, error };
};

const getProductOrderByIds = async (bookingIds: string[]) => {
  const query = bookingIds.join(",");

  const { data, error } = await apiRequest(
    "get",
    `/${ROUTE_PREFIX}?ids=${query}`,
  );

  return { data, error };
};

const updateProductOrderStatus = async (orderId: string, status: string) => {
  const { data, error } = await apiRequest(
    "put",
    `/${ROUTE_PREFIX}/${orderId}/status`,
    { status },
  );

  return { data, error };
};

export {
  orderProducts,
  getProductOrders,
  getProductOrderByIds,
  updateProductOrderStatus,
};
